// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__PVJGA","rightAdornment":"Header_rightAdornment__3BZbq"};